import React from "react";
import RistekHive from "../../../assets/ristek-x-hive.svg";
import DirektoratLogo from "../../../assets/direktorat-pemeliharaan.svg";

export const LoadingScreenFooter = () => {
  return (
    <div className="mb-14 flex flex-col items-center">
      <img src={RistekHive} alt="Ristek x Hive" width={400} />
      <img src={DirektoratLogo} alt="Direktorat UI Logo" width={120} />
    </div>
  );
};
